export default __webpack_public_path__ + "CabinetIllustration.png";